import { ActiveInactive, IntegrationScope } from 'src/api';
import { SelectFieldOption } from 'src/types/components';

export const INTEGRATION_STATUS_FILTER_OPTIONS = [
  {
    value: ActiveInactive.Active,
    label: 'Active',
  },
  {
    value: ActiveInactive.Inactive,
    label: 'Inactive',
  },
] as const satisfies SelectFieldOption[];

export const INTEGRATION_SCOPE_LABELS: Record<IntegrationScope, string> = {
  [IntegrationScope.Income]: 'Income',
  [IntegrationScope.Employment]: 'Employment',
  [IntegrationScope.Government]: 'Government',
  [IntegrationScope.BatchUpload]: 'Batch Upload',
};

export const INTEGRATION_SCOPE_FILTER_OPTIONS = [
  {
    value: IntegrationScope.Income,
    label: INTEGRATION_SCOPE_LABELS[IntegrationScope.Income],
  },
  {
    value: IntegrationScope.Employment,
    label: INTEGRATION_SCOPE_LABELS[IntegrationScope.Employment],
  },
  {
    value: IntegrationScope.Government,
    label: INTEGRATION_SCOPE_LABELS[IntegrationScope.Government],
  },
  {
    value: IntegrationScope.BatchUpload,
    label: INTEGRATION_SCOPE_LABELS[IntegrationScope.BatchUpload],
  },
] as const satisfies SelectFieldOption[];
